export default __webpack_public_path__ + "static/media/firewall.a90f41eb.svg";